
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Option Pack bearbeiten</v-card-title>

              <v-card-text>
                <h3 class="headline">Füllen Sie bitte alle Felder aus.</h3>
                <v-text-field
                  class="pt-5"
                  autofocus
                  placeholder="Name"
                  outlined
                  label="Name"
                  v-model="optionPack.name"
                ></v-text-field>
                <v-text-field
                  class="pt-5"
                  autofocus
                  placeholder="Suche ..."
                  outlined
                  label="Suche"
                  v-model="search"
                  @keyup="applySearch"
                ></v-text-field>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Ausgewählt</th>
                        <th class="text-left">ID</th>
                        <th class="text-left">Motiv</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Preis</th>
                        <th class="text-left">Typ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in showOption" :key="item.id" >
                          <td>
                            <v-checkbox v-model="item.selected"></v-checkbox>
                          </td>
                          <td>{{ item.id }}</td>
                          <td>
                            <v-img max-height="100" contain :src="item.url" v-if="item.url"></v-img>
                          </td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.price }}</td>
                          <td>{{ item.type }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn large color="primary" @click="create">Speichern</v-btn>
                <v-btn large color="error" @click="deleteDialog = true">Löschen</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Option Löschen</v-card-title>

        <v-card-text>Möchten Sie diese Options Paket wirklich löschen?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteDialog = false; deleteOption()"
          >Ja, Ich möchte die Options Paket löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import OptionService from "@/services/OptionService";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    imageFile: null,
    deleteDialog: false,
    uploadingState: 0,
    search: null,
    options: [],
    showOption: [],
    optionPack: {
      name: null,
      options: []
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    
    applySearch() {
      this.showOption = [];
      this.options.forEach(i => {
        let tmp = JSON.stringify(i);
        if(tmp.search(this.search) != -1) {
          this.showOption.push(i);
        }
      });
    },

    async create() {
      try {
        this.loading = true;

        //add user
        try {

          this.optionPack.options = this.options.filter(x => x.selected == true);
          let response = await OptionService.updateOptionPack(
            this.$route.params.id,
            this.optionPack
          );
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "Options"
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async deleteOption() {
      try {
        this.loading = true;

        //add user
        try {
          let response = await OptionService.deleteOptionPack(this.$route.params.id);
        } catch (err) {
          alert(err.message);
        }
        this.loading = false;
        router.push({ name: "Options" });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },

    async refresh() {
      this.loading = true;
      try {
        this.optionPack = (
          await OptionService.getOptionPack(this.$route.params.id)
        ).data;
        this.options = (await OptionService.getOptions()).data;

        this.options.forEach(x => {
          x.selected =
            this.optionPack.options.filter(a => a.id == x.id).length > 0;
          x.show = true;
        });

        this.search = ""
        this.applySearch()

        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

